import {DisclosureChecklistModelId, DisclosureChecklistTemplateId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const disclosureChecklistModels = typedQuery(["tprm", "disclosureChecklistModels"], async () => {
  return await api.tprm.disclosureChecklistModels.list();
});

export const disclosureChecklistModel = typedQuery(
  ["tprm", "disclosureChecklistModel", param<DisclosureChecklistModelId>("disclosureChecklistModelId")],
  async modelId => {
    return await api.tprm.disclosureChecklistModels.get(modelId);
  },
);

export const disclosureChecklistTemplate = typedQuery(
  [
    "tprm",
    "disclosureChecklistTemplate",
    param<DisclosureChecklistModelId>("disclosureChecklistModelId"),
    param<DisclosureChecklistTemplateId>("disclosureChecklistTemplateId"),
  ],
  async (modelId, templateId) => {
    return await api.tprm.disclosureChecklistModels.getTemplate(modelId, templateId);
  },
);
